import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=bdb0e1a4"
import script from "../script/header.js?vue&type=script&lang=js&external"
export * from "../script/header.js?vue&type=script&lang=js&external"
import style0 from "../less/header.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports